module.exports = {"140729001":"东城管理委员会","140729002":"西城管理委员会","140729003":"北城管理委员会","140729100":"翠峰镇","140729101":"静升镇","140729102":"两渡镇","140729103":"夏门镇","140729104":"南关镇","140729105":"段纯镇","140729200":"马和乡","140729201":"英武乡","140729202":"王禹乡","140729203":"坛镇乡","140729204":"梁家焉乡","140729205":"交口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140729.json
// module id = 290
// module chunks = 0